<template>
    <div class="main-box" v-loading="loading">
        <div class="header" v-if="!result && !empty">
            <div class="nav-bar">
                <span class="icon" :class="step === 1?'el-icon-close':'el-icon-arrow-left'" @click="back"></span>
            </div>
            <div class="step">step:{{step}}/{{stepTotal}}</div>
            <div class="progress" :style="{ width: (step/stepTotal * 100) + '%' }"></div>
        </div>
        <div class="body" v-if="!result && !empty">
            <div v-if="step === 1 && post.recruitmentFaceToType !== 3">
                <div class="title">上传简历</div>
                <el-upload action="#" :auto-upload="false" :on-change="fileUploadChange" :show-file-list="false" class="w-100">
                    <template #default>
                        <el-button type="info" style="width:100%">
                            {{ uploadFile.fileName ? uploadFile.fileName : '上传简历' }}
                        </el-button>
                        <div slot="tip" class="el-upload__tip">支持pdf','doc','ppt','docx','pptx','wps','html','jpg','jpeg','png','rtf','txt等简历格式</div>
                    </template>
                </el-upload>
            </div>
            <el-form label-position="top" class="post-form" :model="applyForm" :rules="formRules">
                <div class="title" v-if="step === 2 || post.recruitmentFaceToType === 3">个人信息</div>
                <el-row v-if="step === 2 || post.recruitmentFaceToType === 3">
                    <el-col :span="24" class="form-col">
                        <el-form-item label="姓名" prop="candidateName">
                            <el-input v-model="applyForm.candidateName" placeholder="姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                        <el-form-item label="拼音名/英文名">
                            <el-input v-model="applyForm.englishName" placeholder="拼音名/英文名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col">
                        <el-form-item label="身份证" prop="idCardNumber">
                            <el-input v-model="applyForm.idCardNumber" placeholder="身份证" class="input-with-select">
                                <van-field v-model="applyForm.idCardCategoryName" class="small-field" readonly clickable slot="prepend"
                                    @click="popupOperation={show: true, source: 'idCardCategory', showList: idCardCategoryList, type: 'json',
                                        select: applyForm.idCardCategory, allList: []}" />
                            </el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col">
                        <el-form-item label="民族">
                            <van-field v-model="applyForm.nation" placeholder="民族" class="show-input" readonly clickable right-icon="arrow"
                            @click="popupOperation={show: true, source: 'nation', type:'data', showList: nationList, select: applyForm.nation, allList: nationList};nationFilter = ''"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType === 2">
                        <el-form-item label="政治面貌">
                            <van-field v-model="applyForm.politicalOutlook" placeholder="政治面貌" class="show-input" readonly clickable right-icon="arrow"
                            @click="popupOperation={show: true, source: 'politicalOutlook', type:'data', showList: politicalOutlookList, select: applyForm.politicalOutlook,
                                allList: politicalOutlookList}"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType !== 1">
                        <el-form-item label="出生日期(年龄)">
                            <van-field readonly clickable :value="applyForm.birthdayTemp" class="show-input" placeholder="出生日期(年龄)"
                                @click="datePicker.show = true; datePicker.type = 'birthday';" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col">
                        <el-form-item label="手机号" prop="phone" key="phone">
                            <el-input v-model="applyForm.phone" placeholder="手机号"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                        <el-form-item label="邮箱" prop="email" key="email">
                            <el-input v-model="applyForm.email" placeholder="邮箱"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                        <el-form-item label="紧急联系电话">
                            <el-input v-model="applyForm.emergencyContactPhone" placeholder="紧急联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col">
                        <el-form-item label="性别" prop="gender" key="gender">
                            <van-field v-model="applyForm.genderName" placeholder="性别" class="show-input" readonly clickable right-icon="arrow"
                                @click="popupOperation={show: true, source: 'gender', showList: [{key: 1, value: '男'}, {key:0, value: '女'}], type: 'json',
                                        select: applyForm.gender, allList: []}"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                        <el-form-item label="现居住地">
                            <el-input v-model="applyForm.residentialAddress" placeholder="现居住地"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" >
                        <el-form-item label="户籍所在地"  prop="permanentAddress" key="permanentAddress">
                            <el-input v-model="applyForm.permanentAddress" placeholder="户籍所在地"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType === 1">
                        <el-form-item label="到岗时间">
                            <el-input v-model="applyForm.arrivalTime" placeholder="到岗时间"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType === 2">
                        <el-form-item label="毕业时间">
                            <van-field readonly clickable :value="applyForm.graduationTimeTemp" class="show-input" placeholder="毕业时间"
                                @click="datePicker.show = true; datePicker.type = 'graduationTime';" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType !== 1">
                        <el-form-item label="学历">
                            <van-field v-model="applyForm.highestEducation" placeholder="学历" class="show-input" readonly clickable right-icon="arrow"
                            @click="popupOperation={show: true, source: 'highestEducation', type:'data', showList: highestEducationList, select: applyForm.highestEducation,
                                allList: highestEducationList}"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType === 1">
                        <el-form-item label="您目前或曾经是否在璞泰来新能源科技股份有限公司、其子公司、合资公司面试？">
                            <van-field v-model="applyForm.selfReportRepeatFlagName" placeholder="请选择" class="show-input" readonly clickable right-icon="arrow"
                                @click="popupOperation={show: true, source: 'selfReportRepeatFlag', showList: [{key: 1, value: '是'}, {key:0, value: '否'}], type: 'json',
                                        select: applyForm.selfReportRepeatFlag, allList: []}"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="title" v-if="step === 2">求职意向</div>
                <el-row v-if="step === 2">
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType !== 3">
                        <el-form-item label="期望薪资">
                            <el-input v-model="applyForm.salaryExpectation" placeholder="期望薪资"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="post.recruitmentFaceToType === 2">
                        <el-form-item label="是否接受岗位调剂">
                            <van-field v-model="applyForm.agreePostAdjustFlagName" placeholder="请选择" class="show-input" readonly clickable right-icon="arrow"
                                @click="popupOperation={show: true, source: 'agreePostAdjustFlag', showList: [{key: 1, value: '是'}, {key:0, value: '否'}], type: 'json',
                                        select: applyForm.agreePostAdjustFlag, allList: []}"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col">
                        <el-form-item label="是否接受地点调剂" v-if="post.recruitmentFaceToType === 2">
                            <van-field v-model="applyForm.agreeAreaAdjustFlagName" placeholder="请选择" class="show-input" readonly clickable right-icon="arrow"
                                @click="popupOperation={show: true, source: 'agreeAreaAdjustFlag', showList: [{key: 1, value: '是'}, {key:0, value: '否'}], type: 'json',
                                        select: applyForm.agreeAreaAdjustFlag, allList: []}"/>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div class="title" v-if="step === 2 || post.recruitmentFaceToType === 3">获取招聘信息渠道</div>
                <el-row v-if="step === 2 || post.recruitmentFaceToType === 3">
                    <el-col :span="24" class="form-col">
                        <el-form-item label="获取招聘信息渠道">
                            <van-field v-model="applyForm.recruitmentChannel" placeholder="获取招聘信息渠道" class="show-input" readonly clickable right-icon="arrow"
                            @click="popupOperation={show: true, source: 'recruitmentChannel', type:'data', showList: recruitmentChannelList,
                                select: applyForm.recruitmentChannel, allList: recruitmentChannelList}"/>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="applyForm.recruitmentChannel === '其他'">
                        <el-form-item label="其他渠道">
                            <el-input v-model="applyForm.recruitmentChannelOther" placeholder="其他渠道"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="applyForm.recommenderWorkNo === ''">
                        <el-form-item label="内推人姓名">
                            <el-input v-model="applyForm.recommenderName" placeholder="内推人姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24" class="form-col" v-if="applyForm.recommenderWorkNo === ''">
                        <el-form-item label="内推人电话">
                            <el-input v-model="applyForm.recommenderPhone" placeholder="内推人电话"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="footer" v-if="!result && !empty">
            <el-button type="primary" style="width:100%" :disabled="nextDisabled" @click="nextStep">{{step === stepTotal?'提交申请':'下一步'}}</el-button>
        </div>
        <el-result icon="success" title="成功提示" subTitle="已提交成功！" v-if="result">
        </el-result>
        <el-empty description="抱歉，该职位已停止招聘，去看看其他机会吧！" v-if="empty">
            <el-button type="primary" size="small" @click="otherPostClick">查看其他岗位</el-button>
        </el-empty>
        <van-popup v-model="popupOperation.show" position="bottom">
            <div class="popup-container">
                <div class="nav-bar separate">
                    <div class="btn claer" @click="popupOperation.show = false">取消</div>
                    <div class="btn" @click="popupOperation.select = ''">清除</div>
                    <div class="btn" @click="saveSelect">确认</div>
                </div>
                <div v-if="popupOperation.source === 'nation'" class="separate">
                    <van-field v-model="nationFilter" placeholder="请输入关键字" @input="nationInputFilter" />
                </div>
                <div class="container" :class="popupOperation.source === 'nation'?'more':''">
                    <van-cell :title="popupOperation.type === 'json'?item.value : item"
                        v-for="item of popupOperation.showList" :key="popupOperation.type === 'json'?item.key : item"
                        @click="popupOperation.select = popupOperation.type === 'json'?item.key : item">
                        <template #right-icon>
                            <van-icon name="success" size="20" color="#0082EB" v-show="popupOperation.select === (popupOperation.type === 'json'?item.key : item)" />
                        </template>
                    </van-cell>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="datePicker.show" position="bottom">
            <van-datetime-picker type="date" @confirm="onDateConfirm" @cancel="datePicker.show = false"
                :min-date="datePicker.minDate" :max-date="datePicker.type === 'graduationTime'?datePicker.maxNewDate:datePicker.maxDate" />
        </van-popup>
    </div>
</template>
<script>
import api from '@/api';
import dayjs from 'dayjs';
export default {
    name: 'MobilePostApply',
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback();
            } else {
                let reg = null;
                switch (rule.field) {
                case 'idCardNumber':
                    if (this.applyForm.idCardCategory === 1) {
                        reg = new RegExp('(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    if (this.applyForm.idCardCategory === 2) {
                        reg = new RegExp('^[A-Z]\\d{6}\\([\\dA]\\)$');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    if (this.applyForm.idCardCategory === 3) {
                        reg = new RegExp('[1|5|7]\\d{6}[(\\d)]{3}');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    if (this.applyForm.idCardCategory === 4) {
                        reg = new RegExp('^[A-Z][21]\\d{8}$');
                        if (!reg.test(value)) { // 正则验证不通过，格式不对
                            callback(new Error('身份证格式不正确'));
                        }
                    }
                    break;
                case 'phone':
                    reg = new RegExp('^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\\d{8}$');
                    if (!reg.test(value)) { // 正则验证不通过，格式不对
                        callback(new Error('手机号格式不正确'));
                    }
                    break;
                }
                callback();
            }
        };
        return {
            stepTotal: 2,
            step: 1,
            post: {},
            applyForm: {
                areaId: '',
                postId: '',
                candidateName: '',
                englishName: '',
                age: '',
                birthday: '',
                birthdayTemp: '',
                gender: '',
                genderName: '',
                country: '',
                nation: '',
                politicalOutlook: '',
                idCardNumber: '',
                idCardCategory: 1,
                idCardCategoryName: '身份证',
                residentialAddress: '',
                permanentAddress: '',
                phone: '',
                email: '',
                highestEducation: '',
                graduationTime: '',
                graduationTimeTemp: '',
                arrivalTime: '',
                relationshipFlag: '',
                selfReportRepeatFlag: '',
                selfReportRepeatFlagName: '',
                agreePostAdjustFlag: '',
                agreePostAdjustFlagName: '',
                agreeAreaAdjustFlag: '',
                agreeAreaAdjustFlagName: '',
                salaryExpectation: '',
                recruitmentChannel: '',
                recruitmentChannelOther: '',
                recommenderWorkNo: '',
                recommenderName: '',
                recommenderPhone: ''
            },
            formRules: {
                candidateName: [{ required: true, message: '请输入姓名', trigger: 'change' }],
                idCardNumber: [{ validator: validatePass, trigger: 'blur' }, { required: true, message: '请输入身份证号', trigger: 'change' }],
                phone: [{ required: true, message: '请输入手机号', trigger: 'blur' }, { validator: validatePass, trigger: 'blur' }],
                email: [{ type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }],
                gender: [{ required: true, message: '请输入性别', trigger: 'blur' }],
                permanentAddress: [{ required: true, message: '请输入户籍所在地', trigger: 'blur' }]
            },
            textareaText: '',
            loading: false,
            result: false,
            empty: false,
            nationFilter: '',
            nationList: ['N/A', '汉族', '满族', '蒙古族', '回族', '藏族', '维吾尔族', '苗族', '彝族', '壮族', '布依族', '侗族', '瑶族', '白族', '土家族', '哈尼族', '哈萨克族', '傣族',
                '黎族', '傈僳族', '佤族', '畲族', '高山族', '拉祜族', '水族', '东乡族', '纳西族', '景颇族', '柯尔克孜族', '土族', '达斡尔族', '仫佬族', '羌族', '布朗族', '撒拉族',
                '毛南族', '仡佬族', '锡伯族', '阿昌族', '普米族', '朝鲜族', '塔吉克族', '怒族', '乌孜别克族', '俄罗斯族', '鄂温克族', '德昂族', '保安族', '裕固族', '京族', '塔塔尔族',
                '独龙族', '鄂伦春族', '赫哲族', '门巴族', '珞巴族', '基诺族'],
            idCardCategoryList: [{ value: '身份证', key: 1 }, { value: '身份证（中国香港）', key: 2 }, { value: '身份证（中国澳门）', key: 3 },
                { value: '身份证（中国台湾）', key: 4 }, { value: '身份证（护照）', key: 5 }, { value: '其他证件', key: 6 }],
            politicalOutlookList: ['中共党员', '共青团员', '群众', '其他'],
            highestEducationList: ['本科', '硕士', '博士', '高中', '大专', '中专', 'MBA', '其他'],
            recruitmentChannelList: ['企业官网/官微', '学校/学院就业网', '学校微信公众号', '老师/学长姐推荐', '宣讲会', '线下宣传（海报/折页/横幅等）', '内部推荐', '其他'],
            uploadFile: { file: null, fileName: null },
            datePicker: {
                show: false,
                minDate: dayjs().day(1).month(1).subtract(50, 'year').toDate(),
                maxDate: dayjs().subtract(12, 'year').toDate(),
                maxNewDate: dayjs().day(31).month(12).add(4, 'year').toDate()
            },
            popupOperation: { show: false, source: '', type: '', showList: [], select: '', allList: [] }
        };
    },
    computed: {
        nextDisabled() {
            if (this.post.recruitmentFaceToType === 3 || (this.post.recruitmentFaceToType !== 3 && this.step === 2)) {
                if (this.applyForm.candidateName === '') {
                    return true;
                }
                if (this.applyForm.phone === '' || !new RegExp('^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\\d{8}$').test(this.applyForm.phone)) {
                    return true;
                }
                if (this.applyForm.email !== '' && !new RegExp('^[\\w.\\-]+@(?:[a-z0-9]+(?:-[a-z0-9]+)*\\.)+[a-z]{2,3}$').test(this.applyForm.email.toLocaleLowerCase())) {
                    return true;
                }
                if (this.applyForm.idCardNumber !== '') {
                    const idCardReg = this.applyForm.idCardCategory === 1
                        ? new RegExp('(^[1-9]\\d{5}(18|19|([23]\\d))\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{3}[0-9Xx]$)|(^[1-9]\\d{5}\\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\\d{2}$)')
                        : this.applyForm.idCardCategory === 2 ? new RegExp('^[A-Z]\\d{6}\\([\\dA]\\)$')
                            : this.applyForm.idCardCategory === 3 ? new RegExp('[1|5|7]\\d{6}[(\\d)]{3}')
                                : this.applyForm.idCardCategory === 4 ? new RegExp('^[A-Z][21]\\d{8}$') : null;
                    if (idCardReg && !idCardReg.test(this.applyForm.idCardNumber)) {
                        return true;
                    }
                }
                if (this.applyForm.idCardNumber === '') {
                    return true;
                }
                if (this.applyForm.gender === '') {
                    return true;
                }
                if (this.applyForm.permanentAddress === '') {
                    return true;
                }
                return false;
            }
            return false;
        }
    },
    created() {
        this.applyForm.postId = this.$route.params.id;
        this.applyForm.recommenderWorkNo = this.$store.state.promoterId ? decodeURIComponent(this.$store.state.promoterId) : '';
        this.getDetailByPostId(this.$route.params.id);
    },
    methods: {
        // 根据ID获取岗位详情
        async getDetailByPostId(id) {
            this.loading = true;
            const res = await api.post.getDetailByPostId(id);
            this.loading = false;
            if (res.code !== 200 || !res.data) {
                this.empty = true;
                return;
            }
            res.data.duty = res.data.duty ? res.data.duty.split(/[(\r\n)\r\n]+/) : [];
            res.data.requirement = res.data.requirement ? res.data.requirement.split(/[(\r\n)\r\n]+/) : [];
            this.stepTotal = res.data.recruitmentFaceToType === 1 ? 2 : res.data.recruitmentFaceToType === 2 ? 2 : 1;
            this.post = res.data;
        },
        // 左上角回退
        back() {
            if (this.step === 1) {
                this.$router.go(-1);
            }
            this.step--;
        },
        nextStep() {
            if (this.step < this.stepTotal) {
                this.step++;
                return;
            }
            this.addResume();
        },
        // 添加简历
        async addResume() {
            this.loading = true;
            const res = await api.resume.insertResume(this.applyForm.areaId, this.applyForm.postId, this.applyForm.candidateName, this.applyForm.englishName, this.applyForm.age,
                this.applyForm.birthday, this.applyForm.gender, this.applyForm.country, this.applyForm.nation, this.applyForm.politicalOutlook, this.applyForm.idCardNumber,
                this.applyForm.idCardCategory, this.applyForm.residentialAddress,
                this.applyForm.permanentAddress, this.applyForm.phone, this.applyForm.email, this.applyForm.highestEducation, this.applyForm.graduationTime,
                this.applyForm.arrivalTime, this.applyForm.relationshipFlag, this.applyForm.selfReportRepeatFlag, this.applyForm.agreePostAdjustFlag,
                this.applyForm.agreeAreaAdjustFlag, this.applyForm.salaryExpectation, this.applyForm.recruitmentChannel,
                this.applyForm.recruitmentChannelOther, this.applyForm.recommenderWorkNo, this.applyForm.recommenderName,
                this.applyForm.recommenderPhone, this.uploadFile.file, 0);
            this.loading = false;
            if (res.code !== 200) {
                this.$message.error(res.msg);
                return;
            }
            this.result = true;
        },
        // 文件上传
        fileUploadChange(file) {
            if (file.size > 5242880) {
                this.$message.error('文件大小过大，请修改后再上传！');
                return;
            }
            const fileFormat = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
            if (['pdf', 'doc', 'ppt', 'docx', 'pptx', 'wps', 'html', 'jpg', 'jpeg', 'png', 'rtf', 'txt'].indexOf(fileFormat) === -1) {
                this.$message.error('请上传规定格式简历！');
                return;
            }
            this.uploadFile = { file: file.raw, fileName: file.name };
        },
        // 选择框选择
        saveSelect() {
            let select = this.popupOperation.type === 'json' ? {} : '';
            for (const item of this.popupOperation.showList) {
                if (item.key === this.popupOperation.select && this.popupOperation.type === 'json') {
                    select = item;
                    break;
                }
                if (item === this.popupOperation.select && this.popupOperation.type === 'data') {
                    select = item;
                    break;
                }
            }
            switch (this.popupOperation.source) {
            case 'idCardCategory':
                select = select.key ? select : { key: 1, value: '身份证' };
                this.applyForm.idCardCategory = select.key || '';
                this.applyForm.idCardCategoryName = select.value || '';
                break;
            default:
                if (this.popupOperation.type === 'data') {
                    this.applyForm[this.popupOperation.source] = select || '';
                } else {
                    this.applyForm[this.popupOperation.source] = select.key || '';
                    this.applyForm[this.popupOperation.source + 'Name'] = select.value || '';
                }
                break;
            }
            this.popupOperation.show = false;
        },
        // 时间选择
        onDateConfirm(date) {
            const age = dayjs().diff(dayjs(date), 'year') + 1;
            switch (this.datePicker.type) {
            case 'birthday':
                this.applyForm.birthdayTemp = dayjs(date).format('YYYY-MM-DD') + '(' + age + '岁)';
                this.applyForm.birthday = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
                this.applyForm.age = age;
                break;
            case 'graduationTime':
                this.applyForm.graduationTimeTemp = dayjs(date).format('YYYY-MM-DD');
                this.applyForm.graduationTime = dayjs(date).format('YYYY-MM-DD hh:mm:ss');
            }
            this.datePicker.show = false;
        },
        nationInputFilter() {
            const filterArray = this.popupOperation.allList.filter((item) => {
                return item.toUpperCase().includes(this.nationFilter.toUpperCase());
            });
            this.popupOperation.showList = filterArray;
        },
        // 查看更多岗位点击
        otherPostClick() {
            this.$router.go(-2);
        }
    }
};
</script>
<style lang="scss" scoped>
.main-box {
    overflow: hidden;
    position: relative;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    background: #fff;
    .header {
        position: relative;
        .nav-bar {
            line-height: 50px;
            padding: 0 20px;
            .icon {
                font-size: 23px;
                font-weight: 800;
            }
        }
        .step {
            padding: 0 20px;
            font-size: 10px;
            color: #c1c5cc;
        }
        .progress {
            position: absolute;
            top: 0;
            height: 5px;
            background: #409EFF;
        }
    }
    .body {
        padding: 0 20px;
        box-sizing: border-box;
        position: absolute;
        top: 70px;
        bottom: 65px;
        overflow: auto;
        width: 100%;
        .title {
            font-size: 28px;
            color: #241316;
            font-weight: bold;
            margin-bottom: 10px;
        }
    }
    .footer {
        position: absolute;
        bottom: 0;
        width: 100%;
        padding: 10px 20px;
        box-sizing: border-box;
        border-top: 1px solid #eee;
    }
}
.small-field {
    width: 150px;
    padding: 7px 10px;
}
.popup-container {
    height: 400px;
    position: relative;
    overflow: hidden;
    .separate {
        border-bottom: 1px solid #dddfe3;
    }
    .nav-bar {
        text-align: right;
        height: 60px;
        padding: 0 20px;
        position: relative;
        .btn {
            display: inline-block;
            font-size: 16px;
            font-weight: bold;
            line-height: 60px;
            padding: 0 10px;
            color: #0082EB;
        }
        .btn.claer {
            position: absolute;
            left: 20px;
            color: #323233;
        }
    }
    .container {
        position: absolute;
        top: 60px;
        bottom: 0;
        width: 100%;
        overflow: auto;
    }
    .container.more {
        top: 106px;
    }
}
.show-input {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    padding: 7px 10px;
}
</style>
<style scoped>
.w-100 >>> .el-upload {
    width: 100%;
}
.w-100 >>> .el-upload__tip {
    word-wrap: break-word;
}
.post-form >>> .el-form-item__label {
    line-height: 20px;
    padding-bottom: 5px;
}
.post-form >>> .el-input-group__prepend {
    padding: 0;
}
.input-with-select >>> .el-input-group__prepend{
    background-color: #fff;
}
.input-with-select >>> .el-select .el-input{
    width: 180px;
}
</style>
